var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.16629C2 5.67318 2.39975 5.27344 2.89286 5.27344H21.1071C21.6003 5.27344 22 5.67318 22 6.16629C22 6.65941 21.6003 7.05915 21.1071 7.05915H2.89286C2.39975 7.05915 2 6.65941 2 6.16629ZM2 11.9995C2 11.5063 2.39975 11.1066 2.89286 11.1066H21.1071C21.6003 11.1066 22 11.5063 22 11.9995C22 12.4926 21.6003 12.8923 21.1071 12.8923H2.89286C2.39975 12.8923 2 12.4926 2 11.9995ZM2.89286 16.9995C2.39975 16.9995 2 17.3992 2 17.8924C2 18.3855 2.39975 18.7852 2.89286 18.7852H21.1071C21.6003 18.7852 22 18.3855 22 17.8924C22 17.3992 21.6003 16.9995 21.1071 16.9995H2.89286Z",
    fill: "#100F2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.b58f3770.svg";
export { ForwardRef as ReactComponent };